/* What a run's live stream is doing when it isn't simply live
   (`useRunSocket`'s status). A dropped stream is never a failed run: the
   run goes on on the server, so the screen says so instead. */

export function runSocketNote(status) {
  switch (status) {
    case "reconnecting":
      return "Reconnecting…";
    case "polling":
      return "Live view lost. Following the run's progress every few seconds…";
    case "lost":
      return "Lost contact with the run. It may still be running on the server: open it again later to see its result.";
    default:
      return "";
  }
}

export default function RunSocketNotice({ status, className = "" }) {
  const text = runSocketNote(status);
  if (!text) return null;
  return (
    <span role="status" className={`text-xs font-medium text-amber-700 dark:text-amber-300 ${className}`}>
      {text}
    </span>
  );
}
